import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService extends InsectaServiceBase {
  public getRolePermissionsByRoles(roles: string[]): Observable<string[]> {
    return this.post<string[]>(`/permissions`, 'v1', roles);
  }
}
